import { Swiper } from 'swiper';
import { A11y, Navigation, Scrollbar } from 'swiper/modules';

const propelInit = function() {
const sliders = document.querySelectorAll(
	'.acf-block:not(.block-testimonial-card) .block-testimonials .swiper:not(.swiper-initialized)'
);

sliders.forEach((slider) => {
	const slides = slider.querySelectorAll('.swiper-slide');
	const parentBlock = slider.closest('.acf-block');
	const scrollbar = parentBlock?.querySelector('.swiper-scrollbar');
	let loop = slides.length > 1;

	if (parentBlock?.classList.contains('block-testimonial-image')) {
		loop = false;
	}

	const mobileGap = parentBlock?.dataset?.mobileSliderGap ?? 8;
	const desktopGap = parentBlock?.dataset?.desktopSliderGap ?? 8;

	const settings = {
		loop,
		grabCursor: true,
		spaceBetween: mobileGap,
		slidesPerView: 1,
		modules: [A11y, Navigation],
		a11y: {
			itemRoleDescriptionMessage: 'slide',
		},
		navigation: {
			prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
			nextEl: slider.parentElement.querySelector('.swiper-button-next'),
		},
		breakpoints: {
			768: {
				spaceBetween: desktopGap,
			},
		},
	};

	if (scrollbar) {
		settings.modules.push(Scrollbar);

		settings.scrollbar = {
			el: scrollbar,
			draggable: true,
		};
	}

	// Deferred two to avoid forced reflow. Make sure CSS makes the block appear the same before and after swiper initializes, to avoid CLS.
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			new Swiper(slider, settings);
		});
	});
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['testimonials'] = window.propel.blocks['testimonials'] || {};
window.propel.blocks['testimonials'].script = propelInit;
